export default String.raw`
{% if settings.compareProducts == 'yes' -%}

    {% assign product = product-presentation.Product -%}
    {% assign productsInComparison = customer.ComparisonToolItems | Size -%}
    {% assign maxProductsInComparison = config.Products.ProductComparer -%}
    {% assign remainingProductsCount = maxProductsInComparison | Minus: productsInComparison -%}

    <div class="comparison__bar comparison-bar-js {% if productsInComparison == 0 -%}hidden-js{% endif -%}">
        <div class="comparison__items">
            {% for i in (1..maxProductsInComparison) -%}
            <svg class="{% if productsInComparison < i -%} empty {% endif -%}" height="20" width="20">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#box-{{settings.iconStyle}}"></use>
            </svg>
            {% endfor -%}
        </div>
        <a class="secondary-action-button" href="{{ page.BaseHref }}{{config.DefinedPages.ProductComparisonTool.Url}}">
            <span>{{translations.GoToComparer}}</span>
            <svg height="24" width="24">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#balance-scale-left-{{settings.iconStyle}}"></use>
            </svg>
        </a>
        {% capture currentPageUrl -%}{% include 'partials/common/user-link.html', userLink: page.Url -%}{% endcapture -%}
        <form class="comparison__bar-clear-all clear-comparer-form-js" action="{{ currentPageUrl }}{{ page.QueryString | H }}" method="post">
            <input type="hidden" name="__action" value="Product/ComparisonToolDelete">
            <input type="hidden" name="productId" value="{{product.Id}}">
            {% for productId in customer.ComparisonToolItems -%}
                {% if productId != product.Id %}
                    <input type="hidden" name="productId" value="{{productId}}">
                {% endif %}
            {% endfor -%}
            <button class="pure-button clear-comparer-js">
                <span>{{translations.ProductsComparisonRemove}}</span>
            </button>
        </form>
    </div>
{% endif -%}
`